export const NOTIFICATION_TYPES = [
  {
    labelKeys: ['PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_CREATED'],
    value: 'conversation_creation',
    flagValues: ['conversation_creation'],
  },
  {
    labelKeys: ['PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_ASSIGNED'],
    value: 'conversation_assignment',
    flagValues: ['conversation_assignment'],
  },
  {
    labelKeys: ['PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_ACTIVITY'],
    value: 'conversation_activity',
    flagValues: [
      'conversation_marked_pending',
      'pending_conversation_new_message',
    ],
  },
  {
    labelKeys: ['PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_MENTION'],
    value: 'conversation_mention',
    flagValues: ['conversation_mention'],
  },
  {
    labelKeys: [
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.ASSIGNED_CONVERSATION_NEW_MESSAGE',
    ],
    value: 'assigned_conversation_new_message',
    flagValues: ['assigned_conversation_new_message'],
  },
  {
    labelKeys: [
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.PARTICIPATING_CONVERSATION_NEW_MESSAGE',
    ],
    value: 'participating_conversation_new_message',
    flagValues: ['participating_conversation_new_message'],
  },
  {
    labelKeys: ['PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_FIRST_RESPONSE'],
    value: 'sla_missed_first_response',
    flagValues: ['sla_missed_first_response'],
  },
  {
    labelKeys: ['PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_NEXT_RESPONSE'],
    value: 'sla_missed_next_response',
    flagValues: ['sla_missed_next_response'],
  },
  {
    labelKeys: ['PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_RESOLUTION'],
    value: 'sla_missed_resolution',
    flagValues: ['sla_missed_resolution'],
  },
];

export const EVENT_TYPES = {
  ASSIGNED: 'assigned',
  NOTME: 'notme',
  UNASSIGNED: 'unassigned',
};

export const ALERT_EVENTS = [
  {
    value: EVENT_TYPES.ASSIGNED,
    label: 'assigned',
  },
  {
    value: EVENT_TYPES.UNASSIGNED,
    label: 'unassigned',
  },
  {
    value: EVENT_TYPES.NOTME,
    label: 'notme',
  },
];
